

import React from 'react';
import CountUp from 'react-countup';

const App = () => {
  return (
    <div style={styles.container}>
      {stats.map((item, index) => (
        <div key={index} style={styles.boxee}>
          <h2 style={styles.heading}>{item.label}</h2>
          <div style={styles.counter}>
          <CountUp start={0} end={item.end} duration={2.5} suffix="+" />
          </div>
        </div>
      ))}
    </div>
  );
};

const stats = [
  { label: 'User', end: 20 },
  { label: 'Vendor', end: 50 },
  { label: 'Product', end: 120 },
  { label: 'Delivery', end: 75 },
  { label: 'City', end: 35 },
];

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '20px',
    padding: '20px',
    fontFamily: 'Roboto, sans-serif',
  },
  boxee: {
    backgroundColor: '#2a0947',
    borderRadius: '15px',
    padding: '20px',
    textAlign: 'center',
    width: '150px',
    color: 'white',
    flex: '1 1 150px',
    minWidth: '130px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
  },
  heading: {
    fontWeight: 'bold',
    fontSize: '1.2em',
    marginBottom: '10px',
  },
  counter: {
    fontSize: '2em',
    fontWeight: 'bold',
  },
};

export default App;
